import React from "react";
import {Check, X} from 'lucide-react';
import {ReactComponent as LockedTradeIco} from "../assets/icons/lockedtrade-ico.svg";

const SubscriptionBox = ({
                             title,
                             textFeatures,
                             features,
                             costWeekly,
                             costMonthly,
                             costAnnual,
                             costYearlyWithDiscount,
                             costYearlyWithoutDiscount,
                             buttonText,
                             isHighlighted,
                             highlightTextMonthly,
                             highlightTextAnnual,
                             isMonthly,
                             bottomText,
                             blurOnYearly,
                             monthlyCosts,
                             yearlyCosts,
                             onlyMonthly,
                         }) => {


    const isBlured = onlyMonthly && !isMonthly;

    const costs = {
        ...(isMonthly ? monthlyCosts : yearlyCosts)
    };

    const handleClickSubscription = (url) => {
        window.open(url, '_blank');
    }

    return (
        <div className={`subscription-box--container`}>
            <div
                className={`subscription-box ${isHighlighted ? 'subscription-box--highlighted' : ''}  ${isBlured ? 'subscription-box--blur-filter' : ''}`}>
                <h3 className={`subscription-box--title`}>{title}</h3>
                {costs.costWeekly && (
                    <span className="subscription-box--weekly-price">
                        {costs.costWeekly}
                        {costs.isDiscount && (
                            <span className="subscription-box--weekly-price-without-discount">{costs.costWeeklyWithoutDiscount}</span>
                        )}
                    </span>
                )}
                {costs.costMonthly && (
                    <span className="subscription-box--monthly-price">
                        {costs.costMonthly}
                        {costs.isDiscount && (
                            <span className="subscription-box--monthly-price-without-discount">{costs.costMonthlyWithoutDiscount}</span>
                        )}
                    </span>
                )}
                {costs.costYearly && (
                    <span className="subscription-box--annual-price">
                        {costs.costYearly}
                        {costs.isDiscount && (
                            <span className="subscription-box--annual-price-without-discount">{costs.costYearlyWithoutDiscount}</span>
                        )}
                    </span>
                )}

                {costs.isDiscount && (<span className="subscription-box--annual-discount">{costs.discountPercent}</span>)}

                <p className="subscription-box--text-list">{textFeatures}</p>
                <ul className="subscription-box--features">
                    {features.map((feature, index) => (
                        <li key={index}
                            className={` ${!feature.included ? 'subscription-box--features--not-included' : ''} `}>
                            <LockedTradeIco/>
                            {feature.text}
                        </li>
                    ))}
                </ul>
                <button className={`small-button white-variant`} onClick={() => handleClickSubscription(costs.url)}>
                    {buttonText}
                </button>
            </div>
            {bottomText && (
                <div className={`subscription-box--highlighted-text`}>
                    {bottomText}
                </div>
            )}
            <div className={`subscription-box--overlay ${isBlured ? 'show' : ''} `}></div>
            <div className={`subscription-box--overlay-content ${isBlured ? 'show' : ''} `}>
                <p>Not available<br/>in yearly plan</p>
            </div>
        </div>
    )
}

export default SubscriptionBox;